import React from "react"
import services from "./service"
const Services = () => {
  return (
    <section className="section bg-grey">
        <h1 style={{textAlign:'center', fontSize: '30px', marginBottom: '15px', fontWeight: 'bold'}}>Services</h1>
      <div className="section-center services-center">
        {services.map(service => {
          const { id, icon, title, text } = service

          return (
            <article key={id} className="service">
              {icon}
              <h4>{title}</h4>
              <div className="underline"></div>
              <p>{text}</p>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default Services
